export default __webpack_public_path__ + "static/media/logo.a0143fa8.svg";